import React from 'react';
import link from '../utils/link';
import styles from './LoaderOverlay.css';

export interface LoaderOverlayProps {
	isVisible: boolean;
}

export default class LoaderOverlay extends React.Component<LoaderOverlayProps, {}> {
	render() {
		if (!this.props || !this.props.isVisible) {
			return null;
		}
		
		return (
			<div className={styles.overlay}>
				<div className={styles.loaderWrap}>
					<img className={styles.hippo} src={link('assets', 'loader.png')} alt="Maskot Okna Hned" />
					<div className={styles.waveLoader}>
						<span className={styles.bar} style={{animationDelay: '0.0s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.05s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.1s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.15s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.2s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.25s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.3s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.35s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.4s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.45s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.5s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.55s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.6s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.65s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.7s'}}></span>
						<span className={styles.bar} style={{animationDelay: '0.75s'}}></span>
					</div>
				</div>
			</div>
		);
	}
}

